import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/service-subscriptions', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/service-subscriptions', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const destroy = (studentId, feeSetupId, data = {}) => {
  return httpClient
    .get(`/api/service-subscriptions/${studentId}/${feeSetupId}`, {
      params: data
    })
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const unsubscriptions = (Options = {}) => {
  return httpClient
    .get('/api/service-unsubscriptions', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  get,
  store,
  destroy,
  unsubscriptions
}
